import GoogleMapReact from 'google-map-react';
import React, { useEffect, useState } from 'react';
import { CONFIG } from '../constants';
import MarcadorPunto from '../static/MarcadorPunto.png';

const defaultProps = {
  center: {
    lat: -25.2819,
    lng: -57.635
  },
  zoom: 13
};

const MapPolygon = ({ points, setPoints }) => {
  const apiKey = CONFIG.GOOGLE_MAPS_KEY;
  const [myMap, setMyMap] = useState();
  const [polyline, setPolyline] = useState();
  const [coordenadasList, setCoordenadasList] = useState([]);
  const [googleMaps, setGoogleMaps] = useState();
  const [apiLoaded, setApiLoaded] = useState();
  const [polygon, setPolygon] = useState();

  const dibujarPoligono = (coordenadas, map, maps) => {
    const myPolygon = new maps.Polygon({
      paths: coordenadas.map((item) => ({
        lat: item.lat,
        lng: item.lng
      })),
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });
    myPolygon.setMap(map);
    if (polygon) {
      polygon.setMap(null);
    }
    setPolygon(myPolygon);
  };

  const onClick = (point) => {
    const coordenadas = addLatLng(point);
    setCoordenadasList(coordenadas);
  };

  // Handles click events on a map, and adds a new point to the Polyline.
  const addLatLng = ({ lat, lng }) => {
    const path = polyline.getPath();
    // Because path is an MVCArray, we can simply append a new coordinate
    // and it will automatically appear.
    const nuevoPunto = new googleMaps.LatLng(lat, lng);
    path.push(nuevoPunto);

    const latNueva = nuevoPunto.lat();
    const lngNueva = nuevoPunto.lng();
    const coordenadasActualizadas = [
      ...coordenadasList,
      { lat: latNueva, lng: lngNueva }
    ];
    // setCoordenadasList(coordenadasActualizadas);
    return coordenadasActualizadas;
  };

  const handleApiLoaded = (map, maps) => {
    if (points) {
      dibujarPoligono(points, map, maps);
    }
    const newPolyline = new maps.Polyline({
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });
    newPolyline.setMap(map);
    // Add a listener for the click event
    // addLatLng(event, map, maps)
    // map.addListener('click', (ev) => console.log('a', ev));

    setPolyline(newPolyline);
    setMyMap(map);
    setGoogleMaps(maps);
    setApiLoaded(true);
  };

  const markerStyle = (imageMarker) => ({
    marginLeft: '-8px',
    marginTop: '-8px',
    position: 'absolute',
    width: '16px',
    height: '16px',
    backgroundImage: `url(${imageMarker})`
  });
  const Marker = () => {
    return <div style={markerStyle(MarcadorPunto)} />;
  };

  useEffect(() => {
    if (apiLoaded && points && myMap && googleMaps) {
      dibujarPoligono(points, myMap, googleMaps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiLoaded, googleMaps, myMap, points]);

  useEffect(() => {
    if (apiLoaded) {
      if (points) {
        polyline.setMap(null);
      } else if (myMap) {
        polyline.setMap(myMap);
      }
    }
  }, [myMap, points, polyline, apiLoaded]);

  return (
    <div style={{ height: '60vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: apiKey }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        onClick={onClick}
        onChildClick={(ob, obs) => {
          if (ob === '0') {
            const coordenadas = addLatLng({ lat: obs.lat, lng: obs.lng });
            setPoints(coordenadas);
            setCoordenadasList(coordenadas);
          }
        }}
        yesIWantToUseGoogleMapApiInternals // this is important!
        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      >
        {!points &&
          coordenadasList.map((item, index) => (
            <Marker key={index} lat={item.lat} lng={item.lng} />
          ))}
      </GoogleMapReact>
    </div>
  );
};

export default MapPolygon;
